import md5 from "js-md5";

export default {
  md5, //md5加密
};
